import { buildGrainDescriptionDescriptor } from "../messages/exportMessages.js";

export function isGrainFixed(sourcePanel) {
  return Boolean(sourcePanel.grain);
}

export function isPanelRotationAllowed(sourcePanel) {
  return Boolean(sourcePanel.allowRotation) && !isGrainFixed(sourcePanel);
}

export function applyPanelRotationAllowed(sourcePanel, allowed) {
  if (allowed) {
    return {
      ...sourcePanel,
      allowRotation: true,
      grain: false,
    };
  }
  return {
    ...sourcePanel,
    allowRotation: false,
  };
}

export function applyGrainFixed(sourcePanel, fixed) {
  if (fixed) {
    return {
      ...sourcePanel,
      grain: true,
      allowRotation: false,
    };
  }
  return {
    ...sourcePanel,
    grain: false,
    allowRotation: sourcePanel.grain ? true : sourcePanel.allowRotation,
  };
}

export function describeGrainAndRotation(sourcePanel) {
  return buildGrainDescriptionDescriptor(sourcePanel);
}
